import { Box, List, styled } from "@mui/material";

export const SearchFallbackStyled = styled(Box)({
    backgroundColor: "rgb(80 115 157 / 5%)",
    border: "1px solid rgb(80 115 157 / 5%)",
    borderRadius: "16px 16px 0 0",
    padding: "16px 0 var(--community-comment-input-height)",
    overflow: "hidden",
    margin: "16px -16px 0",
});

export const ListSearchResultsWrapper = styled(List)({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 0,
});

export const ListContainer = styled("div")({
    overflowY: "auto",
    height: "100%",
});

export const BoxSearchSubText = styled(Box)({
    margin: "0 16px 8px",
    fontSize: "14px",
    fontWeight: 700,
    alignItems: "flex-start",
    color: "var(--community-color-secondary-text)",
});
